import { Component } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import {  Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  currentPageUrl: string = '';
  menuLinks: any[]=[];
  hamburgerMenu: any;
  footerLinks: any[]=[];
  contactLinks: any;
  footer_desc: any;
  get_in_touch: any;
  branch_locator: string = '';
  request_callback: string = '';
  tollfree_number: string = '';
  tollfree_number_2: string = '';
  display_tollfree_2: boolean = false;
  title: string = '';
  metaKeywords: any = [];
  metaDescription: string = '';
  
  meta_title:string = '';
  meta_desc:string = '';
  meta_keywords:string = '';
  constructor(@Inject(DOCUMENT) private document: Document,private headermenu: DataService, private router: Router) {
    // this.setRedirectUrl();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        // this.router.url includes any query string / hash (e.g.
        // "/wealth-report?ref=abc"). Strip them so a route with query params
        // still matches its base path in the lists below.
        const currentUrl = this.router.url.split(/[?#]/)[0];

        // Hide header and footer on these routes
        const hideLayoutRoutes = ['/wealth-report', '/wealth-report-temp', '/wealth-report-view', '/realestate-eldeco', '/realestate-eldeco/thankyou'];
        
        // Routes that have their own custom footer
        const hideFooterOnlyRoutes = ['/talk-to-bajajcapital-advisor','/talk-to-bajajcapital','/talk-to-bcl','/talk-to-property-expert','/talk-to-an-expert'];

        // The Retirement Readiness pages have their own header and no site footer.
        const retirement = currentUrl === '/retirement' || currentUrl.startsWith('/retirement/');
        this.isVisible = !hideLayoutRoutes.includes(currentUrl) && !retirement;
        this.IsfooterVisible = !hideLayoutRoutes.includes(currentUrl) && !hideFooterOnlyRoutes.includes(currentUrl) && !retirement;
      });
  }
  isVisible: boolean = true;
  IsfooterVisible: boolean = true;

  ngOnInit() {
    // this.metaForSEO('home_page');  
    this.headerHamburgerFooterLinks();
    
    // Wait for jQuery to be loaded before loading app.js
    const loadAppJs = () => {
      if (typeof $ !== 'undefined') {
        const script = this.document.createElement('script');
        script.src = './assets/js/app.js';
        this.document.head.appendChild(script);
      } else {
        // Retry after a short delay if jQuery isn't loaded yet
        setTimeout(loadAppJs, 500);
      }
    };
    
    // Start checking after 2.5 seconds (after jQuery should be loaded)
    setTimeout(loadAppJs, 2500);
  }

  // metaForSEO(slugname,){
  //   this.headermenu.getDynamicMeta().subscribe(data=>{
  //     data['rows'][0].seo_pages.forEach((v,i) => {
  //       if(v.seo_slug== slugname || v.seo_slug=="/"+slugname){
  //        this.meta_title = v.seo_title;
  //        this.meta_desc = v.seo_description;
  //        this.meta_keywords = v.seo_keywords;
  //        this.titleService.setTitle(this.meta_title);
  //        this.metaService.removeTag('name="keywords"'); 
  //        this.metaService.removeTag('name="description"');
  //        this.metaService.addTags([
  //         { name: 'keywords', content: this.meta_keywords },
  //         { name: 'description', content: this.meta_desc },
  //         { name: 'robots', content: 'index, follow' }  
  //       ]);
  //       return false;
  //       }
  //   }
  //   )}, err=>{
  //     console.log(err);
  //   });
  // }

  headerHamburgerFooterLinks() {
    this.headermenu.getCommonSection().subscribe((response:any) => {
      // For Header links
      this.menuLinks = response['rows'][0]['header_menu'];
      let itemArry : any[]= [];
      this.menuLinks.forEach((element, idx) => {
        let item: any = element;
        if (item['url'].indexOf('www.bajajcapital.com') < 0 && item['url'].indexOf('//bajajcapital.com') < 0 && item['url'].indexOf('dev.bajajcapital.com') < 0 && item['url'].indexOf('stage.bajajcapital.com') < 0 || item['url'].indexOf('nps') > 0) {
          item['target'] = '_blank';
        }
        itemArry.push(item);
      });

      this.menuLinks = itemArry;
     

      // For HamburgerMenu link 
      this.hamburgerMenu = response['rows'][0]['hamburger_menu'];
      let allItemArryss :any[]=[];
      this.hamburgerMenu.forEach((element:any, idx:any) => {
        let itemArryss: any[] = [];
        element['menu'].forEach((el:any, idxx:any) => {
          let item: any = el;
          if (item['link'].indexOf('www.bajajcapital.com') < 0 && item['link'].indexOf('//bajajcapital.com') < 0 && item['link'].indexOf('dev.bajajcapital.com') < 0 && item['link'].indexOf('stage.bajajcapital.com') < 0 || item['link'].indexOf('nps') > 0) {
            item['target'] = '_blank';
          }
          itemArryss.push(item);
        });
        element['menu'] = itemArryss;
        allItemArryss.push(element)
      });
      this.hamburgerMenu = allItemArryss;
      this.hamburgerMenu = response['rows'][0]['hamburger_menu'].filter((item:any) => item.menu.priority !== null);

      this.hamburgerMenu.sort(function (a:any, b:any) {
        a.menu.sort((i:any, j:any) => j.priority - i.priority);
        // return a.menu.priority.localeCompare(b.menu.priority);
      });

      //For Footer Links
      this.footerLinks = response['rows'][0]['footer_menu'];
      // console.log('footerlinks',this.footerLinks)
      let itemArrys :any[]=[];
      this.footerLinks.forEach((element, idx) => {
        let items: any = element;
        if (items['link'].indexOf('www.bajajcapital.com') < 0 && items['link'].indexOf('//bajajcapital.com') < 0 && items['link'].indexOf('dev.bajajcapital.com') < 0 && items['link'].indexOf('stage.bajajcapital.com') < 0 || items['link'].indexOf('nps') > 0) {
          items['target'] = '_blank';
        }
        itemArrys.push(items);
      });
      // console.log('item arrays',itemArrys);
      this.footerLinks = itemArrys;
      // console.log('footerLinks list',this.footerLinks);

      this.contactLinks = response['rows'][0]['footer_contact'];

      this.branch_locator = response['rows'][0].branch_locator;
      this.request_callback = response['rows'][0].request_callback;
      this.tollfree_number = response['rows'][0].tollfree_number;
      this.tollfree_number_2 = response['rows'][0].tollfree_number_secondary;
      if (this.tollfree_number_2 != "") {
        this.display_tollfree_2 = true;
      }
      this.footer_desc = response['rows'][0]['footer_description'];
      this.slidelinks();
      
      if (typeof $ !== 'undefined') {
        $('.search-btn').click( () => {
          $(this).next('.search_section').toggleClass('active');
          return false;
        });
        $('.close_search').click( () => {
          $(this).closest('.search_section').removeClass('active');
          return false;
        });

        /*To open Hamburger menu on clicking 3 horizontal line(Menu) Start*/
        $('.hamburger-menu').click( () => {
          $('.sidebar-menu').addClass('active');
          //return false;

          $('.overlay').click( () => {
            $(this).closest('.active').removeClass('active');
            return false;
          });
        });

        $('#whatsapp').hover(
          function () {
              $('.msg').fadeIn(50);
          },
          function () {
              $('.msg').fadeOut(50);
          }
        );
        /*To open Hamburger menu on clicking 3 horizontal line(Menu) End*/
      }

    });
  }
  slidelinks() {
    if (typeof $ !== 'undefined') {
      $(document).ready( () => {
        $(".sidebar-menu .has-children > a").on("click",  (e:any) => {
          e.preventDefault();
          $(this).parent().toggleClass('active').siblings().removeClass('active');
          $(this).next('.children-wrapper').slideToggle(350).parent().siblings().find('.children-wrapper').slideUp(350);
          e.stopPropagation();
        });
      });
    }
  }


}
